import { RuleResult } from 'types/DeclarationP5'

const C0542Validator = {
  validateConsignmentConsignorRequirement: ({
    security,
    reducedDatasetIndicator,
  }: {
    security: string
    reducedDatasetIndicator?: string
  }): RuleResult => {
    if (security === '0' && reducedDatasetIndicator === 'true') {
      return 'NOT_ALLOWED'
    }

    return 'OPTIONAL'
  },
  validateHouseConsignmentConsignorRequirement: ({
    security,
    reducedDatasetIndicator,
    isConsignmentConsignorPresent,
  }: {
    security: string
    reducedDatasetIndicator?: string
    isConsignmentConsignorPresent?: boolean
  }): RuleResult => {
    if (security === '0' && reducedDatasetIndicator === 'true') {
      return 'NOT_ALLOWED'
    }

    return isConsignmentConsignorPresent ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
} as const

export default C0542Validator
